import { c as _c } from "react/compiler-runtime";
import type { Subscription } from '@algoacademy/backend/modules/marketplace/enums';
import type { GroupMentoringProductDTO, IndividualMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { useEffect } from 'react';
type UseUpdateMentoringProductOnTabChangeProps<T extends IndividualMentoringProductDTO | GroupMentoringProductDTO> = {
  mentoringProduct: T;
  subscription: Subscription;
  setMentoringProduct: React.Dispatch<React.SetStateAction<T>>;
};
export function useUpdateMentoringProductOnTabChange(t0) {
  const $ = _c(4);
  const {
    subscription,
    setMentoringProduct
  } = t0;
  let t1;
  let t2;
  if ($[0] !== setMentoringProduct || $[1] !== subscription) {
    t1 = () => {
      setMentoringProduct(prev => ({
        ...prev,
        subscription
      }));
    };
    t2 = [subscription, setMentoringProduct];
    $[0] = setMentoringProduct;
    $[1] = subscription;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
}